const fonts = {
  body: 'Nunito-Regular',
  heading: 'Nunito-Regular',
  mono: 'Nunito-Regular',
};
export default fonts;
